import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { FontWeight } from 'components/Text';

export const Container = styled.div`
    position: relative;
	
  ${({ infoContent }) => (infoContent ? 'display: unset' : '')};
  ${({ infoContent }) => (infoContent ? 'top: 4px' : '')};
  ${({ infoContent }) => (infoContent ? 'left: 5px' : '')};
    
    span {
        width: 160px;
        background: #FFF;
        padding: 8px;
        border: 1px solid ${Colors.GRAY[4]};
        border-radius: 4px;
        font-size: 14px;
        font-weight: ${FontWeight.Bold};;
        opacity: 1;
        transition: opacity 0.4s;
        position: absolute;
        bottom: calc(100% + 8px);
        left: 50%;
        transform: translateX(-50%);
        color: ${Colors.GRAY[6]};
        white-space: pre-line;
        
        &::before {
            content: '';
            border-style: solid;
            border-color: ${Colors.GRAY[4]} transparent;
            border-width: 6px 6px 0 6px;
            top: 100%;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
    }
`;

export const OutsideClick = styled.div`
    position: fixed; 
    top: 0; 
    bottom: 0; 
    right: 0; 
    left: 0;
    background: transparent
`;